import { useQuery } from "@tanstack/react-query";
import {
	getPassChangeReasons,
	getPassChanges,
	type GetPassChangesParams,
	getProductSizes,
	getProductTypes,
	getStands,
} from "../repositories/PassChangesRepository";

type UsePassChangesParams = Omit<GetPassChangesParams, "signal">;

export const usePassChanges = (params: UsePassChangesParams) =>
	useQuery({
		queryKey: [
			"passChanges",
			params.start,
			params.end,
			params.standId ?? null,
			params.passChangeReasonId ?? null,
			params.productSizeId ?? null,
			params.productTypeId ?? null,
		],
		queryFn: ({ signal }) => getPassChanges({ ...params, signal }),
		enabled: !!params.start && !!params.end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useStands = () =>
	useQuery({
		queryKey: ["passChanges", "stands"],
		queryFn: ({ signal }) => getStands({ signal }),
		staleTime: 5 * 60 * 1000,
	});

export const useProductTypes = () =>
	useQuery({
		queryKey: ["passChanges", "productTypes"],
		queryFn: ({ signal }) => getProductTypes({ signal }),
		staleTime: 5 * 60 * 1000,
	});

export const useProductSizes = () =>
	useQuery({
		queryKey: ["passChanges", "productSizes"],
		queryFn: ({ signal }) => getProductSizes({ signal }),
		staleTime: 5 * 60 * 1000,
	});

export const usePassChangeReasons = () =>
	useQuery({
		queryKey: ["passChanges", "reasons"],
		queryFn: ({ signal }) => getPassChangeReasons({ signal }),
		staleTime: 5 * 60 * 1000,
	});
